export enum HttpRequestType {
    GET,
    POST,
    PUT,
    PATCH,
    DELETE
}